module.exports = __webpack_public_path__ + "static/media/renegades_william_wallace.4c60294a.png";